import React from 'react';
import './style.scss';

interface Props {
    id: string;
    name: string;
    email: string;
    role: string;
    borderColor: 'red' | 'stroke';
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined
}

const User: React.FC<Props> = (props) => {
  const {
    id, name, email, role, borderColor, onClick,
  } = props;
  return (
    <button type="button" id={id} onClick={onClick} className={`card-user-container ${borderColor === 'red' ? 'card-deleted-user-border' : 'card-active-user-border'}`}>
      <div className="active-user-container">
        <div className="d-flex justify-content-start">
          <div className={`user-profile ${borderColor === 'red' ? 'user-profil-deleted' : 'user-profil-active'}`}>
            <div className={`icon-name ${borderColor === 'red' ? 'icon-name-deleted' : 'icon-name-active'}`}>
              {name.slice(0, 1)}
            </div>
          </div>
          <div className="user-header">
            <div className="user-name fz-16">
              {name}
            </div>
            <div className="user-email fz-14">
              {email}
            </div>
          </div>
        </div>

        <div className="label fz-12">
          ROLE:
        </div>
        <div className="role fz-16">
          {role}
        </div>
      </div>
    </button>
  );
};

export default User;
